// One shared ticking `now` for the board's "As Of" freshness readout.
// 1s resolution (unlike Market Probabilities' 30s countdown tick) since this
// panel's whole point is showing how fresh a LIVE curve is — see
// ../market-probabilities/use-now.ts for the sibling pattern.
import { useEffect, useState } from 'react';

const NOW_TICK_MS = 1000;

export function useNow(tickMs: number = NOW_TICK_MS): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const handle = setInterval(() => setNow(new Date()), tickMs);
    return () => clearInterval(handle);
  }, [tickMs]);
  return now;
}
